import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'admin-authorized-population',
    component: () => import(/* webpackChunkName: "authorized-population" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '',
            name: 'authorized-population-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.authorized-population-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "authorized-population-index" */ '@/modules/admin/authorized-population/views/Index.vue')
        }
    ]
}
